import { render, staticRenderFns } from "./areaform.vue?vue&type=template&id=34bce9e3&scoped=true"
import script from "./areaform.vue?vue&type=script&lang=js"
export * from "./areaform.vue?vue&type=script&lang=js"
import style0 from "./areaform.vue?vue&type=style&index=0&id=34bce9e3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@5.2.7_vue-template-compiler@2.6.14_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bce9e3",
  null
  
)

export default component.exports